import { InternalAccessor, TableColumn, TableHoverActions } from '@billy/design-system'
import { TFunction } from 'i18next'
import { useMemo } from 'react'

interface UseProductUnitsListTableColumns {
  handleRowDeleteActionClick: (id: string) => () => void
  t: TFunction
}

type ProductUnitTableItem = { id: string; unit: string; [InternalAccessor.HoverActions]: true }

export const useProductUnitsListTableColumns = ({
  handleRowDeleteActionClick,
  t,
}: UseProductUnitsListTableColumns): TableColumn<ProductUnitTableItem>[] => {
  return useMemo(
    () => [
      {
        Header: t('products.product_units_modal.table.column.unit'),
        accessor: 'unit',
      },
      {
        accessor: InternalAccessor.HoverActions,
        Header: '',
        Cell: ({ row: { original } }) => (
          <TableHoverActions>
            <TableHoverActions.Item
              icon="trash"
              label={t('products.product_units_modal.table.actions.delete')}
              onClick={handleRowDeleteActionClick(original.id)}
            />
          </TableHoverActions>
        ),
      },
    ],
    [t, handleRowDeleteActionClick],
  )
}
